import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';
import { CompoundFilterOptionProps } from './CompoundFilterOption.types';

export const useStyles = ({ isActive }: Pick<CompoundFilterOptionProps, 'isActive'>) => {
  const styles = useStyleSheet(
    (theme) => {
      return {
        button: {
          display: 'flex',
          gap: theme.spacing.secondary,
          boxShadow: 'none !important',
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: isActive ? theme.palette.primary.light : theme.palette.common.white,
          color: theme.palette.common.white,
          backgroundColor: isActive ? theme.palette.primary.main : 'transparent',
          ':hover': {
            borderColor: theme.palette.primary.light,
            backgroundColor: isActive ? theme.palette.primary.light : 'transparent',
            color: theme.palette.common.white,
          },
        },
        icon: {
          stroke: theme.palette.common.white,
        },
      };
    },
    [isActive],
  );

  return styles;
};
